// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dhCanvas{position:absolute!important;top:3.646vw!important;left:1.042vw!important}.canvas-container2 .canvas-container{position:relative!important;top:0!important;left:0!important}", ""]);
// Exports
module.exports = exports;
